import type { SessionRetention } from "@studio/shared";

/** 삭제 예고를 띄우는 창 — 보관 규칙(2026-10-01 jery): «2주 전 진행판 예고». */
export const RETENTION_NOTICE_DAYS = 14;

const DAY_MS = 24 * 60 * 60 * 1_000;

export type RetentionView =
  | { kind: "none" }
  | { kind: "kept"; dateLabel: string; count: number }
  | { kind: "soon"; daysLeft: number; dateLabel: string; count: number };

/**
 * 끝난 수업 카드의 «AI 그림·영상 보관» 한 줄을 정한다.
 * 🔑 날짜는 한국 시각으로 적는다 — 학년도 끝은 «2월 말일 23:59 KST» 라 UTC 로 적으면 3월 1일이 된다.
 */
export function retentionView(retention: SessionRetention | null | undefined, now = new Date()): RetentionView {
  if (!retention || retention.asset_count <= 0) return { kind: "none" };
  const deleteAt = new Date(retention.delete_after);
  const dateLabel = new Intl.DateTimeFormat("ko-KR", {
    timeZone: "Asia/Seoul",
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(deleteAt);
  const daysLeft = Math.max(0, Math.ceil((deleteAt.getTime() - now.getTime()) / DAY_MS));
  if (daysLeft <= RETENTION_NOTICE_DAYS) {
    return { kind: "soon", daysLeft, dateLabel, count: retention.asset_count };
  }
  return { kind: "kept", dateLabel, count: retention.asset_count };
}
